export default require('./tinper.js').default
